export const localtext = {
  AriaLabel: 'Navigation sidebar',
} as const

export const SIDEBAR_WIDTH = 200
